import { render, staticRenderFns } from "./StartComponent.html?vue&type=template&id=4319fcf8&"
import script from "./StartComponent.vue?vue&type=script&lang=ts&"
export * from "./StartComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports